import React from 'react';
import {
  ChoiceButton,
  ChoiceButtonGroup,
  FormGroup,
  Input,
} from '../../../../styles/lesson/lesson.style';
import {
  useLessonCreationState,
  useLessonCreationDispatch,
  OTHER,
} from '../lessonCreation.state';

export const Step1_SubjectLevel: React.FC = () => {
  // Get state and dispatch from the context
  const { user, subjectChoice, levelChoice, subjectOther, levelOther } = useLessonCreationState();
  const dispatch = useLessonCreationDispatch();

  // Derive data from state
  const subjects = (user?.subjects ?? []).filter(Boolean);
  const levels = (user?.levels ?? []).filter(Boolean);

  // --- Handlers that dispatch actions ---
  
  const onChooseSubject = (val: string) => {
    dispatch({ type: 'SET_SUBJECT_CHOICE', payload: val });
  };

  const onChooseLevel = (val: string) => {
    dispatch({ type: 'SET_LEVEL_CHOICE', payload: val });
  };
  
  const handleSubjectOtherChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: 'SET_SUBJECT_OTHER', payload: e.target.value });
  };
  
  const handleLevelOtherChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: 'SET_LEVEL_OTHER', payload: e.target.value });
  };
  

  return (
    <>
      <FormGroup removeSeparator={true}>
        <ChoiceButtonGroup>
          {subjects.map((s) => (
            <ChoiceButton
              key={s}
              isSelected={subjectChoice === s}
              onClick={() => onChooseSubject(s)}
            >
              {s}
            </ChoiceButton>
          ))}
          <ChoiceButton
            isSelected={subjectChoice === OTHER}
            onClick={() => onChooseSubject(OTHER)}
          >
            Other
          </ChoiceButton>
        </ChoiceButtonGroup>

        {subjectChoice === OTHER && (
          <div style={{ marginTop: '1.5rem' }}>
            <Input
              type="text"
              placeholder="Type a subject…"
              value={subjectOther}
              onChange={handleSubjectOtherChange}
              aria-label="Custom subject"
            />
          </div>
        )}
      </FormGroup>

      {/* LEVEL PICKER */}
      <FormGroup>
        <ChoiceButtonGroup>
          {levels.map((lv) => (
            <ChoiceButton
              key={lv}
              isSelected={levelChoice === lv}
              onClick={() => onChooseLevel(lv)}
            >
              {lv}
            </ChoiceButton>
          ))}

          {/* Other */}
          <ChoiceButton
            isSelected={levelChoice === OTHER}
            onClick={() => onChooseLevel(OTHER)}
          >
            Other
          </ChoiceButton>
        </ChoiceButtonGroup>

        {levelChoice === OTHER && (
          <div style={{ marginTop: '1.5rem' }}>
            <Input
              type="text"
              placeholder="Type a level…"
              value={levelOther}
              onChange={handleLevelOtherChange}
              aria-label="Custom level"
            />
          </div>
        )}
      </FormGroup>
    </>
  );
};